import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Head from "@/components/Head";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { trackEvent } from "@/lib/analytics";

const SECTIONS = [1, 2, 3, 4, 5, 6, 7, 8];

const Terms = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col">
      <Head
        title={t("terms.title")}
        description={t("terms.metaDescription")}
        canonical="https://www.mysterymaker.party/terms"
      />
      <Header />

      <main className="flex-1 py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <h1 className="text-4xl font-bold mb-8 text-center">{t("terms.title")}</h1>

          <div className="prose prose-sm md:prose-base lg:prose-lg max-w-none">
            <p><em>{t("terms.lastUpdated")}</em></p>

            {SECTIONS.map((n) => (
              <section key={n}>
                <h2>{t(`terms.s${n}.title`)}</h2>
                <p>{t(`terms.s${n}.body`)}</p>
                {n === 4 && (
                  <p>
                    <Link
                      to="/support?topic=commercial"
                      onClick={() => trackEvent("commercial_request_link_clicked")}
                    >
                      {t("terms.requestCommercial")}
                    </Link>
                    {" "}
                    {t("terms.requestCommercialHint")}
                  </p>
                )}
              </section>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Terms;
